import React from 'react';
import { useIntl } from 'react-intl';
import { ServicePackageConnectorResponse } from '@tff/types/TFF/service-package-connector';
import TFFIcon from '../../styled-components/TFFIcon';
import TFFTypography from '../../styled-components/TFFTypography';
import TFFAccordionNew from '../../styled-components/TFFAccordionNew';
import * as TFF from '@tff/types/TFF';
import { useBookingContext } from '../../hooks/use-booking-context';

interface props {
  serviceResponse?: ServicePackageConnectorResponse;
  passengers: TFF.Passenger[];
}

const ServicesCard: React.FC<props> = ({ serviceResponse, passengers }) => {
  const intl = useIntl();
  const { costFormatter } = useBookingContext();

  return (
    <TFFAccordionNew
      accordionId="services-card"
      summaryChildren={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '50px',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
              <span>
                <TFFIcon iconName="ticket" color="color-theme-variant" />
              </span>
              <TFFTypography
                variant="lead"
                fontWeight="bold"
                text={intl.formatMessage({ id: 'servicePackages.title' })}
              />
            </div>
            <TFFTypography
              text={
                serviceResponse && serviceResponse.success && 'passengers' in serviceResponse.response.servicePackages
                  ? serviceResponse.response.servicePackages.passengers[0].selectedServicePackage.name
                  : ''
              }
              color="color-functional-neutral-900"
            />
          </div>

          <TFFTypography
            color="color-theme-variant"
            fontWeight="bold"
            text={
              !serviceResponse ||
              !serviceResponse.success ||
              !('passengers' in serviceResponse.response.servicePackages)
                ? costFormatter.format(0)
                : costFormatter.format(
                    passengers.length *
                      serviceResponse.response.servicePackages.passengers[0].selectedServicePackage.price.value,
                  )
            }
          />
        </div>
      }
      detailsChildren={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            borderRadius: '4px',
            minHeight: '250px',
            width: '100%',
          }}
        >
          {!serviceResponse ||
          !serviceResponse.success ||
          !('passengers' in serviceResponse.response.servicePackages) ? null : (
            <>
              <div style={{ color: '#09295D', marginLeft: '50px', marginTop: '17px' }}>
                <TFFTypography
                  text={`${serviceResponse.response.servicePackages.passengers[0].selectedServicePackage.name} - ${
                    passengers.length
                  } passenger(s) x ${costFormatter.format(
                    serviceResponse.response.servicePackages.passengers[0].selectedServicePackage.price.value,
                  )}`}
                  fontWeight="bold"
                  color="color-functional-neutral-900"
                ></TFFTypography>
              </div>

              <div style={{ marginLeft: '60px', marginTop: '17px' }}>
                {Array.from(
                  new Set(
                    serviceResponse.response.servicePackages.passengers[0].selectedServicePackage.serviceConfigs
                      .filter(services => services.value === 'true')
                      .map(services => services.service.name),
                  ),
                ).map((serviceName, index) => (
                  <li key={index} style={{ fontSize: '18px' }}>
                    {serviceName}
                  </li>
                ))}
              </div>
            </>
          )}
        </div>
      }
    />
  );
};

export default ServicesCard;
